export default __webpack_public_path__ + "static/media/photo6.0c823188.jpg";